import script from "./Suscripciones.vue?vue&type=script&setup=true&lang=js"
export * from "./Suscripciones.vue?vue&type=script&setup=true&lang=js"

import "./Suscripciones.vue?vue&type=style&index=0&id=33f41616&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33f41616"]])

export default __exports__